// Do not edit directly

export const ButtonClassnameBase: 'button' = 'button';
export const ButtonClassnameSubtle: 'subtle' = 'subtle';
export const ButtonDefaultPaddingX: string = '12px';
export const ButtonDefaultPaddingY: string = '6px';
export const ButtonDefaultBorderRadius: string = '3px';
export const ButtonDefaultFontSize: string = '14px';
export const ButtonDefaultFontWeight: string = '400';
export const ButtonDefaultWidth: string = 'auto';
export const ButtonDefaultTextAlign: string = 'center';
export const ButtonDefaultMaxWidth: string = '100%';
export const ButtonDefaultTransition: string =
  'background 0.1s ease-out,box-shadow 0.15s cubic-bezier(0.47,0.03,0.49,1.38);'; // from AtlasKit styles
export const ButtonDefaultTransitionDuration: string = '0.1s,0.15s';
export const ButtonDefaultLineHeight: string = '20px';
export const ButtonDefaultColor: string = '#172B4D';
export const ButtonDefaultBackgroundColor: string = 'rgba(9,30,66, 4%)';
export const ButtonDefaultHoverBackgroundColor: string = 'rgba(9,30,66, 8%)';
export const ButtonDefaultActiveColor: string = '#0079BF';
export const ButtonDefaultActiveBackgroundColor: string = '#E4F0F6';
export const ButtonDefaultDisabledColor: string = '#A5ADBA';
export const ButtonDefaultDisabledBackgroundColor: string = 'rgba(9,30,66, 4%)';
export const ButtonDefaultSelectedColor: string = '#FFFFFF';
export const ButtonDefaultSelectedBackgroundColor: string = '#172B4D';
export const ButtonPrimaryBackgroundColor: string = '#5AAC44';
export const ButtonPrimaryColor: string = '#FFFFFF';
export const ButtonPrimaryHoverBackgroundColor: string = '#61BD4F';
export const ButtonPrimaryActiveBackgroundColor: string = '#49852E';
export const ButtonDangerBackgroundColor: string = '#CF513D';
export const ButtonDangerColor: string = '#FFFFFF';
export const ButtonDangerHoverBackgroundColor: string = '#EB5A46';
export const ButtonDangerActiveBackgroundColor: string = '#933B27';
export const ButtonStaticPaddingX: string = '16px'; // AK button has 4px margin on content, so this is to visually account for the difference
export const ButtonSubtleBackgroundColor: string = 'rgba(255, 255, 255, 0.3)';
export const ButtonSubtleColor: string = '#FFFFFF';
export const ButtonSubtleHoverBackgroundColor: string =
  'rgba(255, 255, 255, 0.2)';
export const ButtonSubtleActiveBackgroundColor: string =
  'rgba(255, 255, 255, 0.1)';
export const ComponentAppearanceDefault: 'default' = 'default';
export const ComponentAppearanceDanger: 'danger' = 'danger';
export const ComponentAppearanceNone: 'none' = 'none';
export const ComponentAppearancePrimary: 'primary' = 'primary';
export const ComponentAppearanceSecondary: 'secondary' = 'secondary';
export const ComponentAppearanceSubtle: 'subtle' = 'subtle';
export const ComponentClassnameDefault: 'default' = 'default';
export const ComponentClassnameActive: 'active' = 'active';
export const ComponentClassnameActiveAndChecked: 'activeAndChecked' =
  'activeAndChecked';
export const ComponentClassnameBase: 'component' = 'component';
export const ComponentClassnameChecked: 'checked' = 'checked';
export const ComponentClassnameDanger: 'danger' = 'danger';
export const ComponentClassnameDisabled: 'disabled' = 'disabled';
export const ComponentClassnameDisabledAndChecked: 'disabledAndChecked' =
  'disabledAndChecked';
export const ComponentClassnameFocus: 'focus' = 'focus';
export const ComponentClassnameFocusSelected: 'focusSelected' = 'focusSelected';
export const ComponentClassnameHide: 'hide' = 'hide';
export const ComponentClassnameHover: 'hover' = 'hover';
export const ComponentClassnameHoveredAndChecked: 'hoveredAndChecked' =
  'hoveredAndChecked';
export const ComponentClassnameIdle: 'idle' = 'idle';
export const ComponentClassnameIndeterminate: 'indeterminate' = 'indeterminate';
export const ComponentClassnameInvalid: 'invalid' = 'invalid';
export const ComponentClassnameLabel: 'label' = 'label';
export const ComponentClassnameNone: 'none' = 'none';
export const ComponentClassnamePrimary: 'primary' = 'primary';
export const ComponentClassnameQuiet: 'quiet' = 'quiet';
export const ComponentClassnameSecondary: 'secondary' = 'secondary';
export const ComponentClassnameSelected: 'selected' = 'selected';
export const ComponentClassnameStatic: 'static' = 'static';
export const ComponentClassnameSubtle: 'subtle' = 'subtle';
export const ComponentSizeL: 'large' = 'large';
export const ComponentSizeM: 'medium' = 'medium';
export const ComponentSizeS: 'small' = 'small';
export const ComponentSizeXl: 'xlarge' = 'xlarge';
export const ComponentSizeXs: 'xsmall' = 'xsmall';
export const ComponentStateActive: 'active' = 'active';
export const ComponentStateActiveAndChecked: 'activeAndChecked' =
  'activeAndChecked';
export const ComponentStateChecked: 'checked' = 'checked';
export const ComponentStateDisabled: 'disabled' = 'disabled';
export const ComponentStateDisabledAndChecked: 'disabledAndChecked' =
  'disabledAndChecked';
export const ComponentStateFocus: 'focus' = 'focus';
export const ComponentStateFocusSelected: 'focusSelected' = 'focusSelected';
export const ComponentStateHover: 'hover' = 'hover';
export const ComponentStateHoveredAndChecked: 'hoveredAndChecked' =
  'hoveredAndChecked';
export const ComponentStateIdle: 'idle' = 'idle';
export const ComponentStateIndeterminate: 'indeterminate' = 'indeterminate';
export const ComponentStateInvalid: 'invalid' = 'invalid';
export const ComponentDefaultFontSize: string = '14px';
export const CheckboxClassnameBase: 'checkbox' = 'checkbox';
export const CheckboxDefaultHeight: string = '16px';
export const CheckboxDefaultBorderRadius: string = '2px';
export const CheckboxDefaultStrokeWidth: string = '2px';
export const CheckboxDefaultWidth: string = '16px';
export const CheckboxDefaultViewBoxY: string = '18';
export const CheckboxDefaultViewBoxX: string = '18';
export const CheckboxDefaultTransitionDuration: string = '0.2s';
export const CheckboxIconDefaultBorderColor: string = '#DFE1E6';
export const CheckboxIconDefaultBoxColor: string = '#FAFBFC';
export const CheckboxIconDefaultTickColor: string = 'transparent';
export const CheckboxIconHoverBorderColor: string = '#DFE1E6';
export const CheckboxIconHoverBoxColor: string = '#EBECF0';
export const CheckboxIconActiveBorderColor: string = '#E4F0F6';
export const CheckboxIconActiveBoxColor: string = '#E4F0F6';
export const CheckboxIconActiveAndCheckedTickColor: string = '#0079BF';
export const CheckboxIconDisabledBorderColor: string = '#F4F5F7';
export const CheckboxIconDisabledBoxColor: string = '#F4F5F7';
export const CheckboxIconDisabledTickColor: string = '#A5ADBA';
export const CheckboxIconCheckedBorderColor: string = '#0079BF';
export const CheckboxIconCheckedBoxColor: string = '#0079BF';
export const CheckboxIconCheckedTickColor: string = '#FFFFFF';
export const CheckboxIconHoveredAndCheckedBorderColor: string = '#5BA4CF';
export const CheckboxIconHoveredAndCheckedBoxColor: string = '#5BA4CF';
export const CheckboxIconFocusBorderColor: string = '#0079BF';
export const CheckboxIconInvalidBorderColor: string = '#EB5A46';
export const CheckboxIconPathDefaultTransform: string = 'translate(4px, 6px)';
export const CheckboxLabelDefaultPaddingX: string = '8px';
export const CheckboxLabelDefaultPaddingY: string = '6px';
export const CheckboxLabelDefaultAlignItems: string = 'center';
export const DropdownClassnameBase: 'dropdown' = 'dropdown';
export const DropdownClassnameContent: 'content' = 'content'; // wrapper around the content rendered in dropdown if no items are provided
export const DropdownClassnameFitted: 'fitted' = 'fitted'; // fixes the container to the width of the content. This should be used primarily for text items.
export const DropdownDefaultBackgroundColor: string = '#FFFFFF';
export const DropdownDefaultBorderRadius: string = '3px';
export const DropdownDefaultPadding: string = '4px 0';
export const DropdownDefaultWidth: string = '256px';
export const DropdownContentDefaultPadding: string = '4px 12px'; // padding for dropdown if no items are provided
export const DropdownItemDefaultPaddingX: string = '12px';
export const DropdownItemDefaultPaddingY: string = '6px';
export const DropdownItemHoverBackgroundColor: string = 'rgba(9,30,66, 4%)';
export const DropdownItemActiveBackgroundColor: string = '#E4F0F6';
export const IconClassnameBase: 'icon' = 'icon';
export const IconClassnameDark: 'dark' = 'dark';
export const IconClassnameLight: 'light' = 'light';
export const IconClassnameQuiet: 'quiet' = 'quiet';
export const IconDefaultColor: string = '#42526E';
export const IconDefaultHoverColor: string = '#FFFFFF';
export const IconLightColor: string = '#FFFFFF';
export const IconQuietColor: string = '#6B778C';
export const IconDarkColor: string = '#172B4D';
export const IconDisabledColor: string = '#A5ADBA';
export const IconRedColor: string = '#EB5A46';
export const IconGreenColor: string = '#61BD4F';
export const IconYellowColor: string = '#F2D600';
export const IconBlueColor: string = '#0079BF';
export const IconPurpleColor: string = '#C377E0';
export const IconPinkColor: string = '#FF78CB';
export const IconSmallHeight: string = '16px';
export const IconSmallWidth: string = '16px';
export const IconSmallLineHeight: string = '16px';
export const IconMediumHeight: string = '20px';
export const IconMediumWidth: string = '20px';
export const IconMediumLineHeight: string = '20px';
export const IconLargeHeight: string = '24px';
export const IconLargeWidth: string = '24px';
export const IconLargeLineHeight: string = '24px';
export const ListClassnameBase: 'list' = 'list';
export const ListClassnameCell: 'cell' = 'cell'; // This is similar to a list item but can contain more complex elements like an image, meta text, etc.
export const ListClassnameContent: 'content' = 'content';
export const ListClassnameImage: 'image' = 'image';
export const ListClassnameItem: 'item' = 'item';
export const ListClassnameMeta: 'meta' = 'meta';
export const ListItemDefaultPaddingX: string = '12px';
export const ListItemDefaultPaddingY: string = '6px';
export const PopoverClassnameBase: 'popover' = 'popover';
export const PopoverClassnameContent: 'content' = 'content'; // main body of the popover
export const PopoverClassnameHeader: 'header' = 'header'; // contains popover title (if provided), back button (if needed), close button
export const PopoverClassnameTitle: 'title' = 'title'; // contains popover title, if provided
export const PopoverClassnameIconButton: 'iconButton' = 'iconButton';
export const PopoverClassnameBackButton: 'backButton' = 'backButton';
export const PopoverClassnameCloseButton: 'closeButton' = 'closeButton';
export const PopoverDefaultPaddingX: string = '12px';
export const PopoverDefaultBackgroundColor: string = '#FFFFFF';
export const PopoverDefaultBorderRadius: string = '3px';
export const PopoverDefaultBoxSizing: string = 'border-box';
export const PopoverDefaultOutline: string = '0';
export const PopoverDefaultOverflow: string = 'hidden';
export const PopoverSmallWidth: string = '232px';
export const PopoverMediumWidth: string = '304px';
export const PopoverLargeWidth: string = '384px';
export const PopoverXlargeWidth: string = '456px';
export const PopoverPortalDefaultZIndex: number = 1;
export const PopoverPopperDefaultPaddingUnit: number = 4;
export const PopoverHeaderDefaultMarginBottom: string = '8px';
export const PopoverHeaderDefaultPaddingY: string = '0';
export const PopoverHeaderDefaultPaddingX: string = '12px';
export const PopoverTitleDefaultHeight: string = '40px';
export const PopoverTitleDefaultMargin: string = '0';
export const PopoverTitleDefaultPaddingY: string = '0';
export const PopoverTitleDefaultPaddingX: string = '32px';
export const PopoverContentDefaultPadding: string = '12px';
export const PopoverIconButtonDefaultZIndex: string = '2';
export const ScrollbarClassnameBase: 'scollbar' = 'scollbar';
export const ScrollbarDefaultHeight: string = '8px';
export const ScrollbarDefaultWidth: string = '8px';
export const ScrollbarDefaultTrackPieceBackground: string = 'rgba(9,30,66, 8%)';
export const ScrollbarDefaultTrackPieceBorderRadius: string = '4px';
export const ScrollbarDefaultThumbBackground: string = 'rgba(9,30,66, 13%)';
export const ScrollbarDefaultThumbBorderRadius: string = '4px';
export const ScrollbarDefaultThumbHeight: string = '48px';
export const SelectClassnameBase: 'select' = 'select';
export const SelectClassnameContainer: 'container' = 'container';
export const SelectClassnameControl: 'control' = 'control';
export const SelectClassnameMenu: 'menu' = 'menu';
export const SelectClassnameOption: 'option' = 'option';
export const SelectClassnameVal: 'val' = 'val'; // naming this 'value' messes with style-dictionary compiling the other classname values
export const SelectControlDefaultBackgroundColor: string = '#FAFBFC';
export const SelectControlDefaultBorder: string = 'none';
export const SelectControlDefaultBorderRadius: string = '3px';
export const SelectControlDefaultBoxShadow: string = 'inset 0 0 0 2px #DFE1E6';
export const SelectControlDefaultFocusBackgroundColor: string = '#FFFFFF';
export const SelectControlDefaultFocusBoxShadow: string =
  'inset 0 0 0 2px #0079BF';
export const SelectControlDefaultHeight: string = '36px';
export const SelectControlDefaultHoverBackgroundColor: string = '#EBECF0';
export const SelectControlDefaultPaddingX: string = '12px';
export const SelectControlDefaultPaddingY: string = '8px';
export const SelectControlDefaultPosition: string = 'relative';
export const SelectControlDefaultWidth: string = '100%';
export const SelectGroupHeadingDefaultColor: string = '#5E6C84';
export const SelectGroupHeadingDefaultFontSize: string = '12px';
export const SelectGroupHeadingDefaultFontWeight: string = '500';
export const SelectGroupHeadingDefaultLineHeight: string = '16px';
export const SelectGroupHeadingDefaultMarginBottom: string = '4px';
export const SelectInputDefaultLeft: string = '12px';
export const SelectInputDefaultPosition: string = 'absolute';
export const SelectInputDefaultTop: string = '8px';
export const SelectInputDefaultMaxWidth: string = 'calc( 100% - 40px )'; // Since we want to truncate the names of longer input values, we need to limit the width of the value before it hits the caret icon (40px is from font-size plus paddingX)
export const SelectOptionDefaultActiveBackgroundColor: string = '#E4F0F6';
export const SelectOptionDefaultDisabledColor: string = '#A5ADBA';
export const SelectOptionDefaultSelectedBackgroundColor: string = '#172B4D';
export const SelectOptionDefaultSelectedColor: string = '#FFFFFF';
export const SelectSingleValueDefaultDisplay: string = 'block';
export const SelectSingleValueDefaultFontSize: string = '16px';
export const SelectSingleValueDefaultFontWeight: string = '700';
export const SelectSingleValueDefaultLineHeight: string = '20px';
export const SelectSingleValueDefaultMarginLeft: string = '0';
export const SelectSingleValueDefaultTextOverflow: string = 'ellipsis';
export const SelectValueContainerDefaultDisplay: string = 'inherit';
export const SelectValueContainerDefaultMaxHeight: string = '100%'; // Safari has a bug that causes this to break out of the control bounds, so capping the max height correctly aligns the container
export const SelectValueContainerDefaultMaxWidth: string = '96%'; // Since we want to truncate the names of longer options, we need to limit the width of the value before it hits the caret icon
export const SelectValueContainerDefaultPadding: string = '0';
export const SelectValueContainerDefaultPosition: string = 'initial';
export const TextfieldClassnameBase: 'textfield' = 'textfield';
export const TextfieldDefaultBackgroundColor: string = '#FAFBFC';
export const TextfieldDefaultBorderRadius: string = '3px';
export const TextfieldDefaultBoxShadowColor: string = '#DFE1E6';
export const TextfieldDefaultBoxShadowWidth: string = '2px';
export const TextfieldDefaultColor: string = '#172B4D';
export const TextfieldDefaultDisabledBackgroundColor: string = '#EBECF0';
export const TextfieldDefaultDisabledBoxShadowColor: string = '#EBECF0';
export const TextfieldDefaultDisabledColor: string = '#A5ADBA';
export const TextfieldDefaultFocusBackgroundColor: string = '#FFFFFF';
export const TextfieldDefaultFocusBoxShadowColor: string = '#0079BF';
export const TextfieldDefaultFontSize: string = '14px';
export const TextfieldDefaultHoverBackgroundColor: string = '#EBECF0';
export const TextfieldDefaultHoverBoxShadowColor: string = '#DFE1E6';
export const TextfieldDefaultInvalidBoxShadowColor: string = '#EB5A46';
export const TextfieldDefaultLineHeight: string = '20px';
export const TextfieldDefaultMaxHeight: string = '36px';
export const TextfieldDefaultTransition: string =
  'background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out';
export const TextfieldDefaultPaddingX: string = '12px';
export const TextfieldDefaultPaddingY: string = '8px';
export const TextfieldLabelDefaultFontSize: string = '12px';
export const TextfieldLabelDefaultLineHeight: string = '16px';
export const TextfieldLabelDefaultColor: string = '#5E6C84';
export const TextfieldLabelDefaultMarginBottom: string = '4px';
export const TextfieldSubtleBackgroundColor: string = 'transparent';
export const TextfieldSubtleBoxShadowColor: string = 'none';
export const TextfieldSubtleColor: string = '#FFFFFF';
export const TextfieldSubtleHoverBackgroundColor: string =
  'rgba(255, 255, 255, 0.15)'; // Stole this value from `create-board.less` but would be nice if we can change it to a token opacity value.
export const TextfieldSubtleFocusBackgroundColor: string =
  'rgba(255, 255, 255, 0.3)';
export const TextfieldNoneBackgroundColor: string = 'transparent';
export const TextfieldNoneBoxShadowColor: string = 'none';
export const TextfieldNoneHoverBackgroundColor: string = 'transparent';
export const TextfieldNoneFocusBackgroundColor: string = 'transparent';
export const TextfieldPlaceholderDefaultColor: string = '#6B778C';
export const TextfieldPlaceholderSubtleColor: string =
  'rgba(255, 255, 255, 0.6)';
export const AvatarDefaultColor: string = '#DFE1E6';
export const AvatarDefaultHoverColor: string = '#C1C7D0';
export const AvatarDefaultActiveColor: string = '#B3BAC5';
export const DialogDefaultBackgroundColor: string = '#F4F5F7';
export const LabelDefaultColor: string = '#172B4D';
export const LabelDefaultFontSize: string = '14px';
export const LabelDefaultLineHeight: string = '20px';
export const LabelDefaultFontWeight: string = '700';
export const LabelDefaultMarginBottom: string = '2px';
export const LabelDefaultDisplay: string = 'block';
export const CellDefaultActiveBackgroundColor: string = '#E4F0F6';
export const CellDefaultHoverBackgroundColor: string = 'rgba(9,30,66, 4%)';
export const CellDefaultMinHeight: string = '48px';
export const CellContentDefaultPaddingX: string = '12px';
export const CellContentDefaultPaddingY: string = '6px';
export const CellImageDefaultMargin: string = 'auto 0 auto auto'; // Let css-grid take care of the container and margin: auto take care of alignment. Margin-right 0 is to make up for the difference of the content padding.
export const CellImageDefaultWidth: string = '32px';
export const TextDefaultColor: string = '#172B4D';
export const TextDefaultFontWeight: string = '400';
export const TextDefaultFontSize: string = '14px';
export const TextDefaultLineHeight: string = '20px';
export const TextBoldFontWeight: string = '700';
export const TextLightColor: string = '#FFFFFF';
export const TextQuietColor: string = '#5E6C84';
export const TextDisabledColor: string = '#A5ADBA';
export const TextDarkColor: string = '#091E42';
export const GLOBAL_NAMESPACE_PREFIX: string = 'nch-';
export const GLOBAL_MIXIN_PREFIX: string = 'm-';
export const GLOBAL_NATIVE_FONT: string =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif';
export const Z0: string = 'none';
export const Z100: string =
  '0 1px 1px rgba(9,30,66, 25%), 0 0 0 1px rgba(9,30,66, 8%)';
export const Z200: string =
  '0 4px 8px -2px rgba(9,30,66, 25%), 0 0 0 1px rgba(9,30,66, 8%)';
export const Z300: string =
  '0 8px 16px -4px rgba(9,30,66, 25%), 0 0 0 1px rgba(9,30,66, 8%)';
export const Z400: string =
  '0 12px 24px -6px rgba(9,30,66, 25%), 0 0 0 1px rgba(9,30,66, 8%)';
export const Z500: string =
  '0 20px 32px -8px rgba(9,30,66, 25%), 0 0 0 1px rgba(9,30,66, 8%)';
export const ZBorder: string = '0 0 0 1px rgba(9,30,66, 8%)';
export const DividerDefaultColor: string = 'rgba(9,30,66, 13%)';
